import ViewOrder from './ViewOrder';

export default ViewOrder;
